var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18601",
    "data-name": "Gruppe 18601",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283499",
    "data-name": "Pfad 283499",
    d: "M30.5,21a.6.6,0,0,0-.575.6V32.568A1.526,1.526,0,0,1,28.5,34.175h-7a1.526,1.526,0,0,1-1.425-1.607V21.6A.6.6,0,0,0,19.5,21a.563.563,0,0,0-.575.56V32.568A2.673,2.673,0,0,0,21.5,35.325h7a2.673,2.673,0,0,0,2.575-2.757V21.6A.6.6,0,0,0,30.5,21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283500",
    "data-name": "Pfad 283500",
    d: "M31.6,17.925H18.4a.575.575,0,0,0,0,1.15H31.6a.575.575,0,0,0,0-1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283501",
    "data-name": "Pfad 283501",
    d: "M27,14.925H23A1.577,1.577,0,0,0,21.425,16.5v2.575h7.15V16.5A1.577,1.577,0,0,0,27,14.925Zm-4,1.15h4a.426.426,0,0,1,.425.425v1.425h-4.85V16.5A.426.426,0,0,1,23,16.075Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283502",
    "data-name": "Pfad 283502",
    d: "M23.5,23a.545.545,0,0,0-.575.508v7.06a.58.58,0,0,0,1.15,0v-7.06A.545.545,0,0,0,23.5,23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283503",
    "data-name": "Pfad 283503",
    d: "M26.5,23a.545.545,0,0,0-.575.508v7.06a.58.58,0,0,0,1.15,0v-7.06A.545.545,0,0,0,26.5,23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18600",
    "data-name": "Gruppe 18600"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24093",
    "data-name": "Rechteck 24093",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash_white.0af60e61eebee672d342839c1fdc917b.svg";
export { ForwardRef as ReactComponent };